import * as React from "react";
import {API_URL} from '../../../settings/local_settings';
import GoogleButton from "react-google-button";
import {AuthUrlLinkBase} from "./AuthUrlLinkBase";
import {APIClient} from "../../../utils/APIClient";
import { withTranslation } from 'react-i18next';


export class GoogleLinkComponentClass extends AuthUrlLinkBase {

    redirectToAuthPage() {
        const url = this._getAuthURL();
        new APIClient(url).call('GET')
            .then((data) => {
                window.location = data.auth_url
            }).catch((error) => {
            alert(error)
        })
    }

    _getAuthURL(){
        return API_URL + 'get_auth_url/';
    }

    _getDeleteUrl(){
        return API_URL + 'agency/google-connection/delete/';
    }

    renderConnectionButton() {
        return (<GoogleButton onClick={this.redirectToAuthPage} type="light" />);
    }

    renderDisconnectButton() {
        const { t } = this.props;
        return <button className="btn" onClick={this.deleteAgencyConnection}>{t('google_link.disconnect_from_google_ads')}</button>
    }
}

export const GoogleLinkComponent = withTranslation()(GoogleLinkComponentClass);
export default GoogleLinkComponent;
